module.exports = __webpack_public_path__ + "img/xingjiabi2.14c8b30f.jpg";